module.exports = __webpack_public_path__ + "static/media/Kollege.2a82eac9.png";